import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", { fill: "#252729" }, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("g", null, [
              _createElementVNode("g", null, [
                _createElementVNode("g", null, [
                  _createElementVNode("path", {
                    d: "M4.122 3.248l.07.06 1.78 1.782c1.343-.616 2.686-.923 4.028-.923 3.171 0 6.342 1.716 9.513 5.15.262.283.292.704.086 1.02l-.062.083-.255.297c-1.334 1.525-2.71 2.71-4.13 3.553l1.54 1.538c.244.244.244.64 0 .884-.222.222-.57.242-.814.06l-.07-.06-1.814-1.813c-1.393.636-2.825.954-4.297.954-3.506 0-6.605-1.807-9.297-5.42-.217-.293-.218-.688-.012-.979l.068-.084.28-.3c1.36-1.433 2.719-2.55 4.078-3.353L3.308 4.192c-.244-.244-.244-.64 0-.884.222-.222.57-.242.814-.06zM1.918 9.625l-.305.317.009.012c2.34 3.027 4.925 4.536 7.804 4.625l.271.004c1.135 0 2.25-.217 3.345-.656l-1.169-1.17c-.533.364-1.178.576-1.873.576-1.84 0-3.333-1.492-3.333-3.333 0-.695.212-1.34.576-1.874L5.729 6.613c-1.254.695-2.524 1.696-3.81 3.012zM10 5.417c-1.014 0-2.04.206-3.076.623l1.203 1.203c.533-.364 1.178-.576 1.873-.576 1.84 0 3.333 1.492 3.333 3.333 0 .695-.212 1.34-.576 1.874l1.48 1.481c1.308-.727 2.589-1.782 3.846-3.172l.257-.29-.014-.015c-2.77-2.91-5.459-4.369-8.073-4.457L10 5.417zM7.917 10c0 1.15.932 2.083 2.083 2.083.348 0 .676-.085.964-.236l-2.811-2.81c-.151.287-.236.615-.236.963zM10 7.917c-.348 0-.676.085-.964.236l2.811 2.81c.151-.287.236-.615.236-.963 0-1.15-.932-2.083-2.083-2.083z",
                    transform: "translate(-866 -394) translate(500 96) translate(40 260) translate(0 28) translate(320 4) translate(6 6)"
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }